import { Pressable, Linking } from 'react-native';
import { Text, Breakpoint, useBreakpoint } from '@bonanza-social/moonlight';
import { useCallback } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { FooterLink as FooterLinkType } from '../FooterLinks/FooterLinks.constants';
import { logError } from '@bonanza-social/toolkit/logging';

function FooterLink({ labelKey, miscPath, link, navigateTo }: FooterLinkType) {
  const { t } = useTranslation('account');
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const breakpoint = useBreakpoint();
  const isDesktop = breakpoint === Breakpoint.DESKTOP;

  const handlePress = useCallback(() => {
    if (miscPath) {
      navigation.navigate('MiscScreen', { path: miscPath });
    } else if (link) {
      Linking.openURL(link).catch((err) =>
        logError('Failed to open URL:', err),
      );
    } else if (navigateTo) {
      navigation.navigate(navigateTo);
    }
  }, [miscPath, link, navigateTo, navigation]);

  return (
    <Pressable
      onPress={handlePress}
      style={{ width: isDesktop ? 'auto' : '100%' }}
    >
      <Text
        variant="body-m-semi"
        color="darkSurfacePrimary"
        paddingBottom={{
          desktop: 'space-0',
          tablet: 'space-800',
          mobile: 'space-800',
        }}
        textAlign="center"
        width={{ desktop: 'auto', tablet: '100%', mobile: '100%' }}
      >
        {t(labelKey)}
      </Text>
    </Pressable>
  );
}

export default FooterLink;
